import Kubesolo from '@/assets/ico/vendor/kubesolo.svg?c';

import { Widget, WidgetBody, WidgetTitle } from '@@/Widget';
import { Button } from '@@/buttons';
import { Link } from '@@/Link';

import { EnvironmentId } from '../types';

export function KubeSoloWidget({
  environmentId,
}: {
  environmentId: EnvironmentId;
}) {
  return (
    <Widget>
      <WidgetTitle icon={Kubesolo} title="KubeSolo" />
      <WidgetBody className="flex items-center gap-2">
        <span>This environment runs KubeSolo.</span>
        <Button
          as={Link}
          props={{
            to: 'portainer.endpoints.endpoint.kubesolo',
            params: { id: environmentId },
          }}
          color="link"
          data-cy="environment-kubesolo-link"
        >
          View its version and configuration
        </Button>
      </WidgetBody>
    </Widget>
  );
}
